import { ApiHandler } from "./ApiHandler";

const DataFetching = async (
    setLoding,
    url,
    method,
    token,
    dispatch,
    navigate,
    setFilteredData,
    setTotalPages,
    body,
    setResetSearch,
    resetSearch,
) => {
    setLoding(true);
    try {
        const result = await ApiHandler(url, method, body, token, dispatch, navigate);
        if (result.data.status.code === 1) {
            if (result.data.status.code === 1 && result.data !== null) {
                setFilteredData(result?.data.data?.history);
                setTotalPages(result?.data.data?.total_record_fatch);
            } else {
                setFilteredData([]);
            }
        } else {
            setFilteredData([]);
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    } finally {
        setLoding(false);
        if (resetSearch) {
            setResetSearch(false);
        }
    }
};

export default DataFetching;
